import _ from 'lodash';
import React, {
  useState,
  useEffect,
  useCallback,
} from 'react';
import {
  toast,
  ToastContainer,
} from 'react-toastify';
import LoadingOverlay from 'react-loading-overlay';
import {
  Col,
  Row,
  Button
} from 'react-bootstrap';
import BasicLayout from '../../layouts/basiclayout';
import {
  qalBoxDeleteMediaHook,
  qalBoxSearchMediaTagHook,
} from '../../hooks';
import {
  getDeletableMediaTagAndGenre,
  getMediaIdsToDelete,
  getMediaTagColumns,
  getMediaTagDisplayData,
  getValuesFromRow,
} from './helper';
import {
  DEFAULT_SUPPORTED_LANGUAGE,
} from './Constants';
import {
  confirmAlert,
} from 'react-confirm-alert';
import AppModal from '../../widgets/modal';
import {
  ScaleLoader,
} from 'react-spinners';
import QalboxTable from '../../widgets/qalbox-table';
import createMediaTagForm from './createMediaTagForm';
import { qalBoxCreateMediaTagHook } from "../../hooks";
import CreateMediaTag from './createMediaTagForm';

const MediaTags = () => {
  const [ searchCriteria, setSearchCriteria ] = useState({language: DEFAULT_SUPPORTED_LANGUAGE, active: 'true'});
  const [ responseData, setOperationData ] = qalBoxSearchMediaTagHook();
  const [ deleteResponseData, setDeleteOperationData ] = qalBoxDeleteMediaHook();
  const [ action, setMediaTagAction ] = useState('Create');
  const [ mediaTagObject, setMediaTagObject] = useState({
    id: null,
    name: ""
  });

  const handleNewMediaTagName = (e) => {
    const { name, value } = e.target;
    setMediaTagObject(prevState => {
      return {
        id: null,
        [name]: value,
      };
    });
  };


  const [createUpdateData, doCreateOrUpdate] = qalBoxCreateMediaTagHook();

  const displayData = getMediaTagDisplayData(_.get(responseData, 'data', []));
  const isLoading = _.get(responseData, 'isLoading', false);
  const isDeleting = _.get(deleteResponseData, 'isDeleting', false);
  const tableError = _.get(responseData, 'isError', false) && {
    message: _.get(responseData, 'errorMsg', 'Something went wrong.'),
    isError: true,
  };

  const handleSaveNewMediaTagName = async (event) => {
    setMediaTagObject(prevState => {
      const object = prevState;
      const fileUpdateHookConfig = {};
      doCreateOrUpdate({
        items:object,
        onAddOperationComplete,
        ...fileUpdateHookConfig,
      });
      requestData(searchCriteria);
      return {
        ...prevState
      }
    });
  };

  const onAddOperationComplete = () => {
    if (createUpdateData) {
      requestData(searchCriteria);
    } else {
      alert("Creation of New Media Tag failed.");
    }
  };

  const onOperationComplete = operationData => {
    console.log("sadasas");
    if(operationData.isError) {
      toast.error(operationData.errorMsg, {
        position: toast.POSITION.BOTTOM_LEFT
      });
    }
  };

  const onDeleteComplete = operationData => {
    requestData(searchCriteria);
    if(operationData.isError) {
      toast.error(operationData.errorMsg, {
        position: toast.POSITION.BOTTOM_LEFT
      });
    } else {
      toast.success(`Selected media tag items deleted successfully.`, {
        position: toast.POSITION.BOTTOM_LEFT
      });
    }
  };

  const requestData = useCallback(
    _.debounce(searchCriteriaObj => {
      setOperationData({
        searchConfig: {
          language_code: searchCriteriaObj.language,
          active: searchCriteriaObj.active,
        },
        onOperationComplete,
      });
    }, 400),
    [ searchCriteria ]
  );

  useEffect(() => {
    requestData(searchCriteria);
  }, [ searchCriteria ]);

  const createMediaTagModal = (action = "Create", editableObject = null) => {
    setMediaTagAction(action);
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <AppModal
            show={true}
            showBody={true}
            showFooter={false}
            headingText={(action == 'Create') ? `Create a new Media Tag` : `Update Media Tag`}
            modalBody={ <CreateMediaTag handleNewMediaTagName={handleNewMediaTagName} setSearchCriteria={setSearchCriteria} action={action} mediaTagObject={mediaTagObject} editableObject={editableObject} onClose={onClose}/>}
            modalBodyClassName={'precalcs-diff-merge-view'}
            handleClose={onClose}
          />
        );
      }
    });
  };

  const onDeleteSelected = (selectedFlatRows) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <AppModal
            show={true}
            showBody={true}
            headingText={`Are you sure want to delete the following ${_.size(selectedFlatRows)} media tag items ?`}
            modalBody={getDeletableMediaTagAndGenre(selectedFlatRows)}
            modalBodyClassName={'precalcs-diff-merge-view'}
            closeButtonText={'No'}
            okButtonText={'Yes, Delete'}
            handleClose={onClose}
            handleOk={() => {
              onClose();
              console.log(getMediaIdsToDelete(selectedFlatRows))
              setDeleteOperationData({
                deleteConfig: {
                  media_tag_ids: getMediaIdsToDelete(selectedFlatRows),
                  language_code: searchCriteria.language,
                  deleteType: 'mediaTag'
                },
                onOperationComplete: onDeleteComplete,
              });
            }}
          />
        );
      }
    });
  };

  const onEditSelected = (selectedFlatRows) => {
    const editableRow = _.get(selectedFlatRows[0], 'values');
    const editableObject = getValuesFromRow(editableRow);
    setMediaTagObject(prevState => {
      return {
        id: editableObject.id,
        name: editableObject.name,
      };
    });
    createMediaTagModal("Update", editableObject);
  }

  const columns = getMediaTagColumns();

  return (
    <LoadingOverlay
      active={isDeleting}
      spinner={<ScaleLoader />}
      text='Deleting the selected media tag items.'
    >
      <BasicLayout pagePermission="moderate_precalc">
        <ToastContainer autoClose={2000}/>
        <Row>
          <Col md={9}>
            <h3 className='content_editor_title'>{'Media Tags'}</h3>
          </Col>
          <Col md={3} style={{paddingTop: '20px'}}>
              <Button
                onClick={ () => {
                  createMediaTagModal("Create");
                }}
                className='margin-all3 btn btn-success'
                style={{backgroundColor:"green", padding: '10px 20px'}}
                  >
                Create
              </Button>
          </Col>
        </Row>
        <QalboxTable 
          table={{
            data: displayData, 
            columns: columns, 
            handleDelete: onDeleteSelected,
            handleEdit: onEditSelected,
            isLoading: isLoading,
            tableError: tableError
          }}
        />
      </BasicLayout>
    </LoadingOverlay>
  );
};

export default MediaTags;